import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PeopleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"people"}/>
}
